import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PriceModel } from './Price.model';
import { CatalogReferenceModel } from './CatalogReference.model';
export class LineItemModel {
  constructor(lineItemModel) {
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "membersOnly", void 0);
    _defineProperty(this, "hasPolicies", void 0);
    _defineProperty(this, "catalogReference", void 0);
    _defineProperty(this, "salePrice", void 0);
    _defineProperty(this, "unitPrice", void 0);
    _defineProperty(this, "totalPrice", void 0);
    _defineProperty(this, "confirmedQuantity", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "description", void 0);
    _defineProperty(this, "shippable", void 0);
    this.id = lineItemModel.id;
    this.membersOnly = lineItemModel.membersOnly;
    this.catalogReference = lineItemModel.catalogReference;
    this.salePrice = lineItemModel.salePrice;
    this.unitPrice = lineItemModel.unitPrice;
    this.totalPrice = lineItemModel.totalPrice;
    this.confirmedQuantity = lineItemModel.confirmedQuantity;
    this.name = lineItemModel.name;
    this.description = lineItemModel.description;
    this.hasPolicies = lineItemModel.hasPolicies;
    this.shippable = lineItemModel.shippable;
  }
  static fromV1(sdkLineItem, modelContext) {
    var _sdkLineItem$productN, _sdkLineItem$productN2, _sdkLineItem$physical;
    return new LineItemModel({
      id: sdkLineItem._id,
      membersOnly: Boolean(sdkLineItem.membersOnly),
      catalogReference: CatalogReferenceModel.fromV1(sdkLineItem.catalogReference),
      salePrice: PriceModel.fromV1(sdkLineItem.priceBeforeDiscounts, modelContext),
      unitPrice: PriceModel.fromV1(sdkLineItem.price, modelContext),
      totalPrice: PriceModel.fromV1(sdkLineItem.lineItemPrice, modelContext),
      confirmedQuantity: sdkLineItem.quantity,
      name: ((_sdkLineItem$productN = sdkLineItem.productName) == null ? void 0 : _sdkLineItem$productN.translated) ?? ((_sdkLineItem$productN2 = sdkLineItem.productName) == null ? void 0 : _sdkLineItem$productN2.original) ?? '',
      description: getDescription(sdkLineItem.descriptionLines),
      hasPolicies: hasPolicies(sdkLineItem.policies),
      shippable: Boolean((_sdkLineItem$physical = sdkLineItem.physicalProperties) == null ? void 0 : _sdkLineItem$physical.shippable)
    });
  }
  static fromV2(lineItem, modelContext) {
    var _lineItem$attributes, _lineItem$source, _lineItem$pricing, _lineItem$pricing2, _lineItem$pricing3, _lineItem$quantityInf, _lineItem$name, _lineItem$name2, _lineItem$attributes2, _lineItem$attributes3, _lineItem$attributes4;
    return new LineItemModel({
      id: lineItem._id,
      membersOnly: Boolean((_lineItem$attributes = lineItem.attributes) == null ? void 0 : _lineItem$attributes.membersOnly),
      catalogReference: CatalogReferenceModel.fromV2((_lineItem$source = lineItem.source) == null ? void 0 : _lineItem$source.catalogReference),
      salePrice: PriceModel.fromV2((_lineItem$pricing = lineItem.pricing) == null || (_lineItem$pricing = _lineItem$pricing.breakdown) == null ? void 0 : _lineItem$pricing.salePrice, modelContext),
      unitPrice: PriceModel.fromV2((_lineItem$pricing2 = lineItem.pricing) == null ? void 0 : _lineItem$pricing2.unitPrice, modelContext),
      totalPrice: PriceModel.fromV2((_lineItem$pricing3 = lineItem.pricing) == null ? void 0 : _lineItem$pricing3.totalPrice, modelContext),
      confirmedQuantity: (_lineItem$quantityInf = lineItem.quantityInfo) == null ? void 0 : _lineItem$quantityInf.confirmedQuantity,
      name: ((_lineItem$name = lineItem.name) == null ? void 0 : _lineItem$name.translated) ?? ((_lineItem$name2 = lineItem.name) == null ? void 0 : _lineItem$name2.original) ?? '',
      description: getDescription((_lineItem$attributes2 = lineItem.attributes) == null ? void 0 : _lineItem$attributes2.descriptionLines),
      hasPolicies: hasPolicies((_lineItem$attributes3 = lineItem.attributes) == null ? void 0 : _lineItem$attributes3.policies),
      shippable: Boolean((_lineItem$attributes4 = lineItem.attributes) == null || (_lineItem$attributes4 = _lineItem$attributes4.physicalProperties) == null ? void 0 : _lineItem$attributes4.shippable)
    });
  }
}
function getDescription(descriptionLines) {
  return (descriptionLines == null ? void 0 : descriptionLines.reduce((acc, descriptionLine) => {
    var _descriptionLine$name, _descriptionLine$name2, _descriptionLine$plai, _descriptionLine$plai2, _descriptionLine$colo, _descriptionLine$colo2;
    acc = acc !== '' ? `${acc} |` : acc;
    return `${acc} ${((_descriptionLine$name = descriptionLine.name) == null ? void 0 : _descriptionLine$name.translated) ?? (/* istanbul ignore next */(_descriptionLine$name2 = descriptionLine.name) == null ? void 0 : _descriptionLine$name2.original)}: ${((_descriptionLine$plai = descriptionLine.plainText) == null ? void 0 : _descriptionLine$plai.translated) ?? ((_descriptionLine$plai2 = descriptionLine.plainText) == null ? void 0 : _descriptionLine$plai2.original) ?? ((_descriptionLine$colo = descriptionLine.colorInfo) == null ? void 0 : _descriptionLine$colo.translated) ?? ((_descriptionLine$colo2 = descriptionLine.colorInfo) == null ? void 0 : _descriptionLine$colo2.original)}`;
  }, '')) ?? '';
}
function hasPolicies(policies) {
  return Boolean(policies && policies.length > 0);
}
//# sourceMappingURL=LineItem.model.js.map